import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-header">
        <h2>
          Haz que tu marca <span>crezca</span> <br /> con Moti Digital
        </h2>
        <div className="button-container-footer">
          <img src="/images/Footer/Motipuntotes.svg" alt="arrow" />
          <a
            className="cta-button"
            href="https://api.whatsapp.com/send/?phone=%2B5213323104081&text&type=phone_number&app_absent=0"
            style={{ textDecoration: 'none', color: 'inherit' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>Empezar ahora</span>
          </a>

        </div>
      </div>

      <hr className="divider" />

      <div className="footer-content">
        {/* Izquierda */}
        <div className="footer-left">
          <div className="logo-section">
            <div className="logo-moti-container">

              <img src="/images/logo/Moti Logo.svg" alt="moti logo" className="moti-logo" />
              <img src="/images/logo/Logo Moti Blanco.svg" alt="moti logo" className="moti-logo" />
            </div>
            <p>
              La innovación no se detiene. Mantente en contacto y sé parte de las ideas,
              proyectos y soluciones que marcan tendencia en el mundo de la impresión.
            </p>
          </div>

          <div className="">
            <h4>Valores</h4>
            <div className="icons">
              <div className="valor">
                <img src="/images/Footer/Rush.svg" alt="Rush" />
                <p>Rush</p>
              </div>
              <div className="valor">
                <img src="/images/Footer/Pasión.svg" alt="Pasión" />
                <p>Pasión</p>
              </div>
              <div className="valor">
                <img src="/images/Footer/Equipo.svg" alt="Equipo" />
                <p>Equipo</p>
              </div>
              <div className="valor">
                <img src="/images/Footer/Alegría.svg" alt="Alegría" />
                <p>Alegría</p>
              </div>
              <div className="valor">
                <img src="/images/Footer/Adaptabilidad.svg" alt="Adaptabilidad" />
                <p>Adaptabilidad</p>
              </div>
            </div>
            <small>Encontramos satisfacción en los retos.</small>
          </div>
        </div>

        {/* Centro */}
        <div className="footer-center">
          <h4>Nosotros</h4>
          <p><strong>Misión</strong><br />
            Identificar constantemente nuevas oportunidades de negocio para marcas y personas.
          </p>
          <p><strong>Propósito</strong><br />
            Impulsar la comunicación visual de las marcas a través de soluciones de impresión innovadoras,
            personalizadas y de alta calidad.
          </p>

          <h4>Síguenos en redes sociales</h4>
          <div className="social-icons">
            <a href="https://www.facebook.com/MotiDigitalMX" target="_blank" rel="noopener noreferrer">
              <img src="/images/Footer/Facebook.svg" alt="Facebook" />
            </a>
            <a href="https://www.instagram.com/motidigital/" target="_blank" rel="noopener noreferrer">
              <img src="/images/Footer/Instagram.svg" alt="Instagram" />
            </a>
            <a href="https://mx.pinterest.com/motifabrics/" target="_blank" rel="noopener noreferrer">
              <img src="/images/Footer/Pinterest.svg" alt="Pinterest" />
            </a>
          </div>
        </div>

        {/* Derecha */}
        <div className="footer-right">
          <h4>Contacto</h4>
          <div className="tooltip-container">
            <a
              href="https://www.google.com/maps/place/Moti+Digital/@20.644634,-103.3659598,17z/data=!3m1!4b1!4m6!3m5!1s0x8428adf38cd8c13d:0xdf9c6d31fa15304b!8m2!3d20.644634!4d-103.3659598!16s%2Fg%2F11g6xf2rws?entry=ttu&g_ep=EgoyMDI1MTAyMC4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              className="map-link"
            >
              Calle 1 No. 1375 – 5, Zona Industrial C.P. 44980,<br />
              Guadalajara, Jalisco, México.
            </a>

            <div className="tooltip">
              📍 Ir al mapa
              <div className="tooltip-arrow"></div>
            </div>
          </div>
          <div className="tooltip-container">
            <a href="tel:3338117143" className="map-link">
              <p><strong>Teléfono:</strong><br />33 3811 7143</p>
            </a>
            <div className="tooltip">
              📞 Hacer llamada
              <div className="tooltip-arrow"></div>
            </div>
          </div>

          <div className="tooltip-container">
            <a href="mailto:contacto@motidigital.com" className="map-link">
              <p><strong>Correo electrónico:</strong><br />contacto@motidigital.com</p>
            </a>
            <div className="tooltip">
              ✉️ Enviar correo
              <div className="tooltip-arrow"></div>
            </div>
          </div>

          <div className="tooltip-container">
            <a href="#/blog" className="map-link">
              <p>Nuestro blog</p>
            </a>
            <div className="tooltip">
              ✍️ Visita nuestro blog
              <div className="tooltip-arrow"></div>
            </div>
          </div>

          <a href="#/AvisoPrivacidad" className="privacy">Conoce nuestro aviso de privacidad</a>

          <h4>Material de ventas</h4>
          <a href="https://gofile.me/2LQdY/DIasKH2QJ" className="material-btn" target="_blank" rel="noopener noreferrer">
            <img src="/images/Footer/bulbo.svg" alt="folder" />
            Accede aquí
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
